import React, { useMemo } from 'react';
import { Route, Switch } from 'react-router-dom';
import { NotFound } from '@cko/dashboard-shared';

import {
  useNavigation,
  NavigationHelperContextProvider,
  DynamicHeaderContextProvider,
} from '../../providers';
import { PageRenderer } from '../../layout/PageRenderer';
import { RedirectWithParams } from './RedirectWithParams';

export const ApplicationRouter = () => {
  const { availableRoutes } = useNavigation();
  const routeIds = useMemo(() => Object.keys(availableRoutes), [availableRoutes]);

  return (
    <Switch>
      {routeIds.map((routeId) => {
        const route = availableRoutes[routeId];
        if (!route.shouldRedirect) {
          return (
            <Route key={routeId} exact path={route.path}>
              <DynamicHeaderContextProvider>
                <NavigationHelperContextProvider>
                  <PageRenderer route={route} routeId={routeId} />
                </NavigationHelperContextProvider>
              </DynamicHeaderContextProvider>
            </Route>
          );
        }
        const firstValidChildRoute = route.redirectRouteIds?.filter(
          (childRouteId: string) => availableRoutes[childRouteId] !== undefined,
        )[0];

        if (firstValidChildRoute === undefined) {
          return (
            <Route key={routeId} exact path={route.path}>
              <NotFound />
            </Route>
          );
        }

        const redirectRoute = availableRoutes[firstValidChildRoute];

        return <RedirectWithParams key={routeId} exact to={redirectRoute.path} from={route.path} />;
      })}
      <NotFound />
    </Switch>
  );
};
